<template>
  <div class="wrapper add-lang">
    <b-modal
      id="modal"
      v-model="isOpen"
      header-bg-variant="light"
      footer-bg-variant="light"
      :title="$t('pages.user-cv.education.modal.title', 'Edit education')"
      :hide-footer="addNew"
      :ok-title="$t('generic.ok', 'OK')"
      ok-only
      @hidden="$emit('closeModal'); addNew = false;"
    >
      <div class="d-flex justify-content-between">
        <strong
          class="my-auto"
          style="font-size: 1rem;"
        >
          {{ $t('pages.user-cv.education.modal.education', 'Your education data') }}
        </strong>
        <b-button
          v-if="!addNew"
          size="sm"
          variant="success"
          @click="addEducation()"
        >
          {{ $t('generic.add-new', 'Add new') }}
        </b-button>
      </div>
      <hr>
      <div class="mb-3">
        <div v-if="!addNew">
          <div v-if="!educations">
            {{ $t('pages.user-cv.education.modal.no-educations', 'No educations yet!') }}
          </div>
          <div
            v-for="education in educations"
            :key="education.id"
            class="mb-3"
          >
            <div class="row">
              <div class="col-12 col-md-9">
                <h1
                  class="mb-0"
                  style="font-size: 1.2rem !important"
                >
                  {{
                    $t(
                      'pages.user-cv.education.entry',
                      '{title} in {name}',
                      {
                        title: education.title,
                        name: education.name,
                      }
                    )
                  }}
                </h1>
                <div style="color: #999;">
                  {{ education.place }}
                </div>
                <div style="color: #999;">
                  {{ education.startDate }} -
                  <span v-if="!education.ongoingCourse">{{ education.endDate }}</span>
                  <span v-else>{{ $t('generic.present', 'Present') }}</span>
                </div>
              </div>
              <div class="col-12 col-md-3 my-auto">
                <b-button
                  variant="outline-danger"
                  size="sm"
                  @click="remove(education.id)"
                >
                  {{ $t('generic.delete', 'Delete') }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="addNew">
          <div
            class="go-back mb-2"
            @click="resetOnBack()"
          >
            <font-awesome-icon icon="arrow-left" /> {{ $t('generic.back', 'Back') }}
          </div>
          <label for="educationSelect">{{ $t('pages.user-cv.education.modal.form.title', 'Title') }}</label>
          <b-form-select
            id="educationSelect"
            v-model="educationSelected"
            size="sm"
            class="mb-2"
            :options="educationOptions"
          />
          <label for="nameInut">{{ $t('pages.user-cv.education.modal.form.specialty', 'Name of the course / Specialty') }}</label>
          <b-form-input
            id="nameInut"
            v-model="name"
            size="sm"
            class="mb-2"
          />
          <div class="grey">
            {{
              $t(
                'generic.char-counter',
                '{current}/{max} characters',
                {
                  current: courseNameLength,
                  max: 200
                }
              )
            }}
          </div>
          <b-form-checkbox
            v-model="ongoingCourse"
            class="mb-2"
          >
            {{ $t('pages.user-cv.education.modal.form.ongoing', 'Currently studying') }}
          </b-form-checkbox>
          <div class="row">
            <div class="col-12 col-md-6">
              <label for="dateInput">{{ $t('pages.user-cv.education.modal.form.start-date', 'Start date') }}</label>
              <b-form-input
                v-model="startDate"
                type="month"
                size="sm"
              />
            </div>
            <div class="col-12 col-md-6">
              <label for="dateInput">{{ $t('pages.user-cv.education.modal.form.end-date', 'End date') }}</label>
              <b-form-input
                v-model="endDate"
                type="month"
                :disabled="ongoingCourse"
                size="sm"
              />
            </div>
          </div>
          <label
            class="mt-2"
            for="placeInput"
          >{{ $t('pages.user-cv.education.modal.form.study-center', 'Study center') }}</label>
          <b-form-input
            id="placeInput"
            v-model="place"
            size="sm"
          />
          <div class="grey">
            {{
              $t(
                'generic.char-counter',
                '{current}/{max} characters',
                {
                  current: placeNameLength,
                  max: 200
                }
              )
            }}
          </div>
          <b-button
            variant="success"
            class="mt-3 float-right"
            :disabled="!readyToSave"
            @click="saveNew"
          >
            {{ $t('generic.save', 'Save') }}
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { educations } from "@/assets/data";
export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    educations: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      addNew: false,
      educationSelected: null,
      name: "",
      ongoingCourse: false,
      startDate: "",
      endDate: "",
      place: "",
    }
  },
  computed: {
    educationOptions: () => educations(),
    courseNameLength() {
      return this.name.length;
    },
    placeNameLength() {
      return this.place.length;
    },
    readyToSave() {
      return this.educationSelected != null &&
        this.courseNameLength <= 200 && this.placeNameLength <= 200 &&
        ((this.endDate > this.startDate) || (this.startDate && this.ongoingCourse));
    }
  },
  methods: {
    addEducation() {
      this.addNew = true;
    },
    saveNew() {
      let elementId;
      if(this.educations && this.educations.length) {
        elementId = this.educations[this.educations.length-1].id + 1;
      } else {
        elementId = 1;
      }
      let education = {
        id: elementId,
        title: this.educationSelected,
        name: this.name,
        ongoingCourse: this.ongoingCourse,
        startDate: this.startDate,
        endDate: this.endDate,
        place: this.place
      };
      this.axios.put('/cv/update/educations', { education: education })
        .then(response => this.$emit('updateCv', response.data))
        .catch();

      this.addNew = false;
    },
    resetOnBack() {
      this.addNew = false;
      this.educationSelected = null;
      this.name = "";
      this.ongoingCourse = false;
      this.startDate = "";
      this.endDate = "";
      this.place = "";
    },
    remove(educationId) {
      this.axios.delete('/cv/delete/educations/' + educationId)
        .then( response => this.$emit('updateCv', response.data))
        .catch();
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
  .add-lang {
    font-size: 0.9rem;
  }

 .modal-title {
    font-weight: 600 !important;
  }

  label {
    margin-bottom: 0;
  }

  .grey {
    color: #999;
  }

  .go-back {
    cursor: pointer;
    color: #658bc7;
  }
</style>

